<app-modal
  [isOpen]="true"
  [title]="'Editar reproceso'"
  [widthPx]="700"
  [heightPx]="480"
  (closeModal)="onClose()"
>
  <div class="edit-modal-wrapper">
    <p class="text-sm text-gray-600 mb-6">
      Actualiza el estado del reproceso para dar seguimiento a la observación
    </p>

    <div class="toggle-container">
      <span class="toggle-label">Tiene reproceso</span>
      <label class="toggle-switch">
        <input type="checkbox" [checked]="observation().isReprocess" disabled />
        <span class="toggle-slider"></span>
      </label>
    </div>

    <!-- Grid de campos -->
    <div class="form-grid">
      <!-- Causa del reproceso (solo lectura) -->
      <div class="form-field">
        <span class="input-label-item">Causa del reproceso</span>
        <div class="readonly-dropdown">
          {{ observation().reprocessCause || 'Sin causa registrada' }}
        </div>
      </div>

      <!-- Estado (editable solo si no está solucionado) -->
      <div class="form-field">
        <span class="input-label-item">Estado</span>
        @if (isLoadingStatuses()) {
          <div class="readonly-dropdown">Cargando estados...</div>
        } @else if (isResolved()) {
          <div
            class="readonly-dropdown resolved-state"
            title="Las observaciones con estado 'Solucionado' no pueden ser modificadas porque ya fueron cerradas."
          >
            <span class="flex items-center gap-2">
              <span class="status-badge status-resolved">{{
                observation().reprocessStatus
              }}</span>
              <span class="text-xs text-gray-500">(Cerrado - No editable)</span>
            </span>
          </div>
        } @else {
          <select
            class="status-dropdown"
            [(ngModel)]="selectedStatusId"
            [disabled]="isLoading()"
          >
            @for (status of statusOptions(); track status.id) {
              <option [value]="status.id">{{ status.name }}</option>
            }
          </select>
        }
      </div>

      <!-- Observación (solo lectura) -->
      <div class="form-field col-span-full">
        <span class="input-label-item">Observación</span>
        <div class="readonly-textarea">
          {{
            observation().reprocessObservation || 'Sin observación registrada'
          }}
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="flex justify-between gap-4 mt-8 pt-6 border-t border-gray-200">
      <app-button
        label="Cancelar"
        [type]="ButtonTypeEnum.PRIMARY_OUTLINE"
        [size]="ButtonSizeEnum.MD"
        [disabled]="isLoading()"
        (handleClick)="onClose()"
      >
      </app-button>
      <app-button
        label="Guardar"
        [type]="ButtonTypeEnum.PRIMARY"
        [size]="ButtonSizeEnum.MD"
        [disabled]="!canSave()"
        (handleClick)="onSave()"
      >
      </app-button>
    </div>
  </div>
</app-modal>
